// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import store from './store'
import '@/icons' // icon
import '@/permission' // permission control
import OnoffToggle from 'vue-onoff-toggle'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {postRequest, getRequest, putRequest, deleteRequest} from '@/utils/api'

Vue.use(ElementUI);
Vue.use(VueI18n) // 挂载
Vue.use(OnoffToggle)
Vue.prototype.postRequest = postRequest
Vue.prototype.putRequest = putRequest
Vue.prototype.getRequest = getRequest
Vue.prototype.deleteRequest = deleteRequest

// 获取默认语言
let locale
if (localStorage.lang && (localStorage.lang=='zh-CN' || localStorage.lang=='en-US')){
  locale = localStorage.lang
} else {
  locale = 'zh-CN'
}

const i18n = new VueI18n({
  locale: locale,    // 语言标识
  silentTranslationWarn: true,
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': require('./lang/zh').default,   // 通过require引入中文语言包
    'en-US': require('./lang/en').default    // 通过require引入英文语言包
  }
})
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store,
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js